import { render, staticRenderFns } from "./HeroIcon.vue?vue&type=template&id=76a10963&scoped=true"
import script from "./HeroIcon.vue?vue&type=script&lang=ts"
export * from "./HeroIcon.vue?vue&type=script&lang=ts"
import style0 from "./HeroIcon.vue?vue&type=style&index=0&id=76a10963&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76a10963",
  null
  
)

export default component.exports